export enum Operation {
    Error = 0,
    Selected = 1,
    Inserted = 2,
    Updated = 3,
    Deleted = 4
}

export class ResponseMessage {
    isSuccessfully: boolean;
    messages: string[];

    constructor() {
        this.isSuccessfully = false;
        this.messages = [];
    }
}

export interface ResponseApi<T> {
    operation: Operation;
    status: ResponseMessage;
    statusCode: number;
    count: number;
    data?: T;
    listData: T[];
    page?: number;
    pageSize?: number;
    totalResults?: number;
    totalPages?: number;
    firstPage?: string;
    lastPage?: string;
    nextPage?: string;
    prevPage?: string;
}

export function GetVoidResponseApi<T>(): ResponseApi<T> {
    return {
        operation: Operation.Selected,
        status: new ResponseMessage(),
        statusCode: 500,
        count: 0,
        data: undefined, // Mejor que null para evitar problemas de tipo
        listData: [],
        page: 0,
        pageSize: 0,
        totalResults: 0,
        totalPages: 0,
        firstPage: '',
        lastPage: '',
        nextPage: '',
        prevPage: '',
    };
}
